<template>
    <v-menu v-model="shows" v-if="detect == 'pc'" top offset-y offset-overflow nudge-top="10" :close-on-content-click="false">
        <template #activator="{ attrs, on }">
            <slot v-bind="{ attrs, on }" />
        </template>
        <client-chat-view />
    </v-menu>
    <v-bottom-sheet v-model="shows" v-else-if="detect == 'mobile'" fullscreen>
        <template #activator="{ attrs, on }">
            <slot v-bind="{ attrs, on }" />
        </template>
        <client-chat-view />
        <v-btn fixed top right text fab @click="shows = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-bottom-sheet>
</template>

<script>
import detect from "@/plugins/detect";

import ClientChatView from "./client-chat-view.vue";

export default {
    components: {
        ClientChatView,
    },
    data: () => ({
        detect,
        shows: false,
    }),
};
</script>

<style>
</style>